import { render } from "./App.vue?vue&type=template&id=bf13670e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bf13670e&lang=scss"

import exportComponent from "/home/runner/work/draw-and-guess/draw-and-guess/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__